import React from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import "./DesarrolloWeb.css";

function IA() {
  return (
    <>
      <SEO
        title="Inteligencia Artificial | Automatización y Chatbots"
        description="Implementación de IA para automatizar procesos y mejorar tu negocio."
        url="https://juancarlosmancharamos.ar/inteligencia-artificial"
      />

      <Menu />

      <HeroInner
        title="Inteligencia Artificial"
        subtitle="Automatización y chatbots para tu negocio"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <h2>Automatizá tu negocio con IA</h2>

        <p>
          Desarrollo soluciones con inteligencia artificial para automatizar
          procesos, atención al cliente y generación de leads.
        </p>

        <p>
          Implementación de chatbots, integraciones con APIs y flujos
          automatizados.
        </p>

        <h3>Beneficios</h3>

        <p>
          Reducción de costos, atención 24/7 y mejora en la conversión de
          clientes.
        </p>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="container text-center">
          <h2>+ servicios</h2>
          <Services />
        </div>
      </section>

      <ChatBot />
      <GlobalScripts />
    </>
  );
}

export default IA;